import script from "./method-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./method-item.vue?vue&type=script&setup=true&lang=ts"

import "./method-item.vue?vue&type=style&index=0&id=3937ef1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3937ef1d"]])

export default __exports__